import React from 'react';
import cls from './ArchiveAccountsList.module.css';
import classNames from 'classnames';
import { AccountItem } from '../../AccountItem/AccountItem';

export const ArchiveAccountsList = ({ accounts }) => {
    return (
        <div className={classNames(cls.wrapper)}>
            {accounts.length ? (
                <>
                    {accounts.map((account) => (
                        <AccountItem key={account.guid} account={account} />
                    ))}
                </>
            ) : (
                <span className={classNames(cls.empty)}>
                    {i18next.t('ArchiveAccountsList.return.empty.text')}
                </span>
            )}
        </div>
    );
};
